export class PrettyPrinter {
	public formatCode(code: string, language?: string, linenums?: number | boolean) {
		const ppo = this.getPrettyPrintOne();
		return ppo(escapeHtml(code), language, linenums);
	}

	public getPrettyPrintOne() {
		return (window as any).prettyPrintOne;
	}
}

const matchHtmlRegExp = /["'&<>]/;
function escapeHtml(unsafe: string) {
	let str = '' + unsafe;
	let match = matchHtmlRegExp.exec(str);

	if (!match) {
		return str;
	}

	let escape = '';
	let html = '';
	let index = 0;
	let lastIndex = 0;

	for (index = match.index; index < str.length; index++) {
		switch (str.charCodeAt(index)) {
			case 34: // "
				escape = '&quot;';
				break;
			case 38: // &
				escape = '&amp;';
				break;
			case 39: // '
				escape = '&#39;';
				break;
			case 60: // <
				escape = '&lt;';
				break;
			case 62: // >
				escape = '&gt;';
				break;
			default:
				continue;
		}

		if (lastIndex !== index) {
			html += str.substring(lastIndex, index);
		}

		lastIndex = index + 1;
		html += escape;
	}

	return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/client/shared/helpers/pretty-printer.service.ts